import { z } from "zod"

export const EventsTypeSchema = z.object({
  id: z.number(),
  type_name: z.string()
})